import { getLocale } from "./locale";

export const formatNumber = (
  number: number,
  options: Intl.NumberFormatOptions = {},
) => {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
    ...options,
  }).format(number);
};

export const formatRowCount = (
  rows: number,
  options: Intl.NumberFormatOptions = {},
) => {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    ...options,
  }).format(rows);
};

export const formatRowCountCompact = (
  rows: number,
  options: Intl.NumberFormatOptions = {},
) => {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    notation: "compact",
    compactDisplay: "short",
    ...options,
  }).format(rows);
};

export function formatCurrency(
  valueInCents: number,
  options: Intl.NumberFormatOptions = {},
) {
  const locale = getLocale();

  const maximumFractionDigits = options.maximumFractionDigits ?? 2;
  const minimumFractionDigits = Math.min(
    options.minimumFractionDigits ?? 2,
    maximumFractionDigits,
  );

  return new Intl.NumberFormat(locale, {
    ...options,
    minimumFractionDigits,
    maximumFractionDigits,
    style: "currency",
    currency: options.currency ?? "eur",
  }).format(valueInCents / 100);
}

export function formatPercent(
  value: number,
  options: Intl.NumberFormatOptions = {},
) {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
    style: "percent",
  }).format(value);
}
